import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NodeService } from 'src/app/core/services/node.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeploymentService } from '../../../../core/services/deployment.service';
import { HpcConfig } from '../../../../core/models/node-config';
import { NodeConfigService } from '../../../../core/services/node-config.service';
import { HpcVMStates } from '../../../../core/models/globals';

@Component({
  selector: 'app-resize-node',
  templateUrl: './resize-node.component.html',
  styleUrls: ['./resize-node.component.scss']
})
export class ResizeNodeComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<ResizeNodeComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { depName: string; cloudType: string; nodeName: string, nodeConfig: string, isResize: boolean, state: string },
    public nodeService: NodeService,
    public depService: DeploymentService,
    private _spinner: NgxSpinnerService,
    public nodeConfigService: NodeConfigService,
    private _snackBar: MatSnackBar) { }

  resizeNodeForm: UntypedFormGroup;
  depName: string = this.data.depName ? this.data.depName : null;
  cloudType: string = this.data.cloudType;
  isFormSubmitted;
  nodeConfigNames: HpcConfig[] = [];
  cloudProvidersList: string[] = [];
  selectedHpcConfig: HpcConfig;
  currentHpcConfig: HpcConfig;
  noteMessage: string = "Note : Resizing node will cause it to reboot";

  ngOnInit(): void {
    this.resizeNodeForm = new UntypedFormGroup({
      nodeSize: new UntypedFormControl(null, [Validators.required]),
    })
    if (this.data.state) {
      if (this.data.state == HpcVMStates.STATE_CODE_STARTED) {
        this.noteMessage = "Note : Resizing an active node will cause it to reboot";
      }
    }
    this.loadNodeConfig();
  }

  hpcConfigChanged(hpcConfigId) {
    this.selectedHpcConfig = this.nodeConfigNames?.find(nd => nd.hpcConfigId == hpcConfigId);
  }

  loadNodeConfig() {
    this.nodeConfigService
      .getHpcConfigDetails(
        this.depName
      )
      .subscribe({
        next: (data) => {
          this.nodeConfigNames = JSON.parse(JSON.stringify(data));
          if (this.nodeConfigNames?.length == 0) {
            this._snackBar.open("No node configuration is available, please add first.", "OK", {
              duration: 5000
            })
            return;
          }
          else if (this.nodeConfigNames?.length == 1) {
            if (this.nodeConfigNames![0].instanceCode?.toLowerCase() == this.data.nodeConfig?.toLowerCase()) {
              this._snackBar.open("No node configuration is available other than current size of node, please add another first.", "OK", {
                duration: 5000
              })
              this.selectedHpcConfig = this.nodeConfigNames![0];
              return;
            }
          }
          else {
            if (this.data.nodeConfig) {
              this.selectedHpcConfig = this.nodeConfigNames?.find(nd => nd.instanceCode?.toLowerCase() == this.data.nodeConfig?.toLowerCase());
              this.currentHpcConfig = this.nodeConfigNames?.find(nd => nd.instanceCode?.toLowerCase() == this.data.nodeConfig?.toLowerCase());
              this.resizeNodeForm?.controls['nodeSize'].setValue(this.data.nodeConfig);
            }
            else {
              this.selectedHpcConfig = this.nodeConfigNames![0];
              this.resizeNodeForm?.controls['nodeSize'].setValue(this.selectedHpcConfig?.instanceCode)
            }
          }
        },
        error: (err) => {
          this._snackBar.open(err?.errorMessage, "OK", {
            duration: 5000
          })
        },
        complete: () => { }
      })
  }

  onClose() {
    this.dialog.close(false)
  }

  onSubmit(form) {
    if (!form.valid) {
      this.resizeNodeForm.markAllAsTouched();
      this._snackBar.open("Make sure all required fields are filled.", "OK", {
        duration: 5000
      })
      this.isFormSubmitted = false;
      return;
    }
    this.isFormSubmitted = true;

    let nodeSize = form?.value.nodeSize;

    if (nodeSize?.toLowerCase() == this.data.nodeConfig?.toLowerCase()) {
      this._snackBar.open(`Node is already of ${nodeSize}, please select other size.`, "OK", {
        duration: 5000
      })
      this.isFormSubmitted = false;
      this.resizeNodeForm.markAllAsTouched();
      return;
    }

    this._spinner.show("addNode");
    this.nodeService.resizeNodeService(this.data?.nodeName, this.depName, nodeSize)
      .subscribe({
        next: (data: any) => {
          this._spinner.hide("addNode")
          this._snackBar.open(data.successMessage, "OK", {
            duration: 5000
          })
          this.dialog.close(true)
        }, error: (err) => {
          this._spinner.hide("addNode")
          this._snackBar.open(err.error?.successMessage, "OK", {
            duration: 5000
          })
          this.isFormSubmitted = false;
          this.dialog.close()
        }
      })
  }
}

